import {FC, useEffect, useState} from 'react';

import {
    AppBar,
    Grid,
    IconButton,
    Toolbar,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    Button,
} from '@material-ui/core';

import {observer} from 'mobx-react-lite';
import CloseIcon from '@material-ui/icons/Close';
import {RouteComponentProps} from 'react-router-dom';
import {AgentStore} from '../AgentStore';
import CRM from '../../APIs/CRM';

interface FormHistoryProps extends RouteComponentProps {
    store: AgentStore;
}

export const FormHistory: FC<FormHistoryProps> = observer(({history}) => {
    const [formHistoryData, setFormHistoryData] = useState<{sortKey: string; formId: string; timestamp: string}[]>([]);

    const loadUserFormHistory = async () => {
        const email = window.location.pathname.split('/')[3];
        if (email) {
            const data = await CRM.GetClientHistoryRecords(email);
            if (!data) {
                throw new Error('Failed to load user from history');
            }
            const processedData = data.forms.map((d: any) => {
                const partitionIndex = d.s.lastIndexOf('-');
                const date = new Date(parseInt(d.s.substr(partitionIndex + 1), 10));
                const formattedDate = `${date.getDate()}/${
                    date.getMonth() + 1
                }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                return {
                    sortKey: d.s,
                    formId: d.s.substr(0, partitionIndex),
                    timestamp: formattedDate,
                };
            });
            setFormHistoryData(processedData);
        }
    };
    useEffect(() => {
        loadUserFormHistory();
    }, []);

    const showFormData = (sortKey: string) => {
        history.push(`${window.location.pathname}/${sortKey}/2`);
    };

    const handleClose = () => {
        history.push(window.location.pathname.replace('/history', '/0'));
    };

    return (
        <>
            {/* // <Dialog open fullScreen onClose={handleClose}> */}
            <AppBar style={{position: 'relative'}}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" style={{marginLeft: 2, flex: 1}}>
                        Form History
                    </Typography>
                </Toolbar>
            </AppBar>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{padding: 30}}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Form-id</TableCell>
                                <TableCell>Timestamp</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {formHistoryData.map((form: any) => (
                                <TableRow>
                                    <TableCell>{form.formId}</TableCell>
                                    <TableCell>{form.timestamp}</TableCell>
                                    <TableCell>
                                        <Button onClick={() => showFormData(form.sortKey)}>View</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        </>
        // </Dialog>
    );
});

export default FormHistory;
